import { ol_events_condition, ol_Extent, ol_extent, ol_Feature, ol_source, ol_interaction } from "@omnia/exports/openlayers"
import { isFunction } from "../utils/utils"
import { IMapContainer } from "./types"
import { getGeometryPoints, observeOpenlayersObject } from "./utils"

export function createDragSelectInteraction(
    map: IMapContainer,
    layer: { getFeatures: () => ol_Feature[] },
    onSelect: (features: ol_Feature[], end: boolean) => void = (f) => map.selectFeatures(f),
    onStart?: () => void,
    onEnd?: () => void

) {

    let interaction: ol_interaction.DragBox
    let _source: ol_source.Vector

    const olmap = map.getMap()

    interaction = new ol_interaction.DragBox({
        condition: ol_events_condition.shiftKeyOnly
    })

    const events = [
        observeOpenlayersObject(interaction, "boxstart", start),
        observeOpenlayersObject(interaction, "boxdrag", () => updateSelection(false)),
        observeOpenlayersObject(interaction, "boxend", () => updateSelection(true))
    ]

    const dispose = () => {
        events.forEach(e => e())
        olmap.removeInteraction(interaction)
    }

    olmap.addInteraction(interaction)

    return {

        get enabled() {
            return interaction.getActive()
        },

        set enabled(value) {
            interaction.setActive(value)
        },

        dispose
    }

    /***/

    function start() {

        _source = new ol_source.Vector({
            features: layer.getFeatures().filter(f => !!f),
            useSpatialIndex: true
        })

        if (isFunction(onStart)) {
            onStart()
        }

    }

    function updateSelection(end: boolean) {

        if (_source) {

            const extent = interaction.getGeometry().getExtent()

            const features = _source
                .getFeaturesInExtent(extent)
                .filter(f => isFeatureCompletelyInExtent(f, extent))

            onSelect(features, end)

        }

        if (end) {

            _source = null

            if (isFunction(onEnd)) {
                onEnd()
            }

        }

    }

}

function isFeatureCompletelyInExtent(feature: ol_Feature, extent: ol_Extent) {

    const geom: any = feature.getGeometry()
    const geomCoords = getGeometryPoints(geom, false).getCoordinates()
    return geomCoords.every(c => ol_extent.containsCoordinate(extent, c))

}

